module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-chofer-rojo.4402a6d4.svg";